export * from './bulk-activate-access-request-dialog.component';
